import styled from "styled-components"

import { colors, spacing } from "@minuthq/meatball-ui-react"
import { Text } from "@minuthq/meatball-ui-react"

import { TUserOrderDetails } from "src/data/billing/types/billingTypes"
import { useTranslate } from "src/i18n/useTranslate"

export function ItemsInShipment({ order }: { order: TUserOrderDetails }) {
  const { t, langKeys } = useTranslate()

  const lineItems = order.line_items

  return (
    <div>
      <Text variant="heading3" marginBottom={spacing.L}>
        {t(langKeys.orders_details_line_items_title)}
      </Text>

      <ItemsGrid>
        {lineItems.map((lineItem) => {
          return (
            <LineItem key={lineItem.sku}>
              <ProductImageBox>
                {lineItem.image_url && (
                  <StyledImage
                    src={lineItem.image_url}
                    alt={lineItem.description}
                  />
                )}
              </ProductImageBox>

              <Text variant="subtitle">
                {lineItem.quantity} x {lineItem.description}
              </Text>
            </LineItem>
          )
        })}
      </ItemsGrid>
    </div>
  )
}

const LineItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.M};
`

const ProductImageBox = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 8px;
  border: 1px solid ${colors.divider};
`

const ItemsGrid = styled.div`
  display: grid;
  gap: ${spacing.XS};
`

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
